<!--首页banner图-->
<template>
  <div class="banner">
    <div class="index-scroll" style="min-width: 1200px">
      <!-- <el-carousel :interval="5000" arrow="always" :height="imgHeight" :class="{'brandHeight': brand}">
        <el-carousel-item v-for="item in homeScroll" :key="item.pic" :class="{'brandHeight': brand}">
          <img  width="2560" height="680" ref="imgHeight" :src="ImgPreUrl+item.pic" @click="goForDetail(item)">
              <div   class="divimg" ref="imgHeight" 
              :style="{
                    backgroundImage: `url(${ImgPreUrl}${item.pic})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center center',
                    backgroundRepeat: 'no-repeat',
                    backgroundAttachment: 'scroll'
                }"
               @click="goForDetail(item)"></div>
        </el-carousel-item>
      </el-carousel> -->
      <div   class="divimg" ref="imgHeight" :style="{backgroundImage: `url(${require('@/assets/images/banner.jpg')})`}"></div>
      <div class="mask"></div>
    </div>
    <!--banner图快捷搜索-->
    <div class="quickSearch">
        <div class="quickSearch-wrap">
          <i class="el-icon-star-on"></i>
          精选优质酒店平台
          <i class="el-icon-star-on"></i>
        </div>
        <div class="quickSearch-content"> 
          <h1>发现理想的住宿体验</h1>
          <span>精选全国 5000+ 家优质酒店，提供一站式预订服务</span>
        </div>
        <!--首页搜索框-->
        <div class="quickSearch-search">
          <!--首页分类选择-->
          <ul class="quickSearch-category mt-3">
              <!--当前城市-->
              <li>
                <div class="category-wrap" @click="OpenFilter(1)">
                  <i class="el-icon-location-outline"></i>
                  <div class="category-city">
                    <span>当前城市</span>
                    <p>{{ searcValue.cityName }}</p>
                  </div>
                  <i class="el-icon-arrow-down" :class="{'active': defaultIndex==1}"></i>
                </div>
                <!--城市选择-->
                <CitySelection v-show="defaultIndex==1" :infoLise="infoLise" @formData="formData" :searcValue="searcValue"></CitySelection>
              </li>
              <!--当前星级-->
              <li>
                <div class="category-wrap" @click="OpenFilter(2)">
                  <i class="el-icon-star-off"></i>
                  <div class="category-city">
                    <span>酒店星级</span>
                    <p v-if="searcValue.star.length==0">不限</p>
                    <div v-else>
                      <p v-if="searcValue.star.length==1">{{searcValue.star[0] | formatVar('HotelStar')}}</p>
                      <p v-else>已选{{ searcValue.star.length }}个</p>
                    </div>
                  </div>
                  <i class="el-icon-arrow-down" :class="{'active': defaultIndex==2}"></i>
                </div>
                <!--星级选择-->
                <StarRat  v-show="defaultIndex==2" @formData="formData"></StarRat>
              </li>
              <!--当前星级-->
              <li >
                <div class="category-wrap" @click="OpenFilter(3)">
                  <i class="el-icon-office-building"></i>
                  <div class="category-city">
                    <span>房间数量</span>
                    <p v-if="searcValue.room_2_type==0">不限</p>
                    <p v-else>{{searcValue.room_2_type | formatVar('twinRoomQuantity')}}</p>
                  </div>
                  <i class="el-icon-arrow-down" :class="{'active': defaultIndex==3}"></i>
                </div>
                <!--房间数量选择-->
                <RoomInventory v-show="defaultIndex==3"  @formData="formData"></RoomInventory>
              </li>
          </ul>
          <div class="search-wrap">
            <el-autocomplete
              class="inline-input"
              v-model="searcValue.title"
              :fetch-suggestions="querySearchAsync"
              placeholder="搜索酒店品牌或名称..."
              :trigger-on-focus="false"
              @select="handleSelect"
              @focus="inputFocus"
              prefix-icon="el-icon-search"
            >
            <template slot-scope="{ item }">
              <!-- v-html 必须用，渲染包裹的span标签 -->
              <span v-html="$verify.highlightKeyword(item.title, searcValue.title)"></span>
            </template>
            </el-autocomplete>
            <el-button type="primary" class="bottom" icon="el-icon-search" @click="searchJump(searcValue)">立即搜索</el-button>
          </div>

        </div>
    </div>
  </div>
</template>

<script>
import CitySelection from '@/views/HomePage/IndexComps/IndexPage/Components/CitySelection.vue'
import StarRat from './Components/StarRat.vue'
import RoomInventory from './Components/RoomInventory.vue'
import {mapActions} from 'vuex'
  export default {
    name: 'ScrollCarousel',
    props: {
      homeScroll: {
        type: Array,
        default: () => {
          return [];
        }
      }
    },
    components: {
      CitySelection,
      StarRat,
      RoomInventory
    },
    data() {
      return {
        imgHeight: 680+'px',
        restaurants: [],
        //搜索框的值
        searcValue: {
          title:'',                      //搜索酒店名称
          id:'',                         //搜索酒店ID
          star:'',                       //搜索星级
          room_2_type:'',                //搜索房间数量
          cityName:'杭州',                //当前城市
          cityId:'940',                     //当前城市ID
        },
        defaultIndex:0,                //显示的tab索引
        infoLise:{},                    //热门城市列表
      }
    },
    watch: {
      searcValue: {
        handler(val) {
          // 直接取 title
          let titleVal = (val.title || '').trim()
          // 赋值回输入框（避免空格显示）
          this.searcValue.title = titleVal
        },
        deep: true
      },
    },
    computed: {
      brand () {
        return this.$route.path == '/index_brand'
      }
    },
    mounted() {
      window.onresize = this.$GFUN.damControl(this.setCarouselHeight, 400);
      this._timer = setTimeout(() => {
        this.setCarouselHeight();
      }, 500)
      this.getHotCity();
    },
    methods: {
      ...mapActions(['POST_SearchDocHotel','POST_GetAllCity']),
      /*设置轮播图高度=图片高度,品牌馆全屏*/
      setCarouselHeight() {
        if (this.brand) this.imgHeight =680+ 'px'
        else this.imgHeight = 680+'px'
      },
      /*轮播图跳转控制*/
      goForDetail(item) {
        if(item.link!=''){
           window.open(item.link, '_blank');
        }
        // if (!this.brand) {
        //   if (index == 0)  this.$router.push({path: '/index/index_hotel', query: {name: '君澜'}});
        //   else if (index == 1) this.$router.push('/index/leather_city');
        //   else if (index == 2) this.$router.push('/index/index_homestay/homestay_detail/10');
        // }
      },
      loadAll() {
        return [
          { "value": "三全鲜食（北新泾店）", "address": "长宁区新渔路144号" },
          { "value": "鲜食三全（北新泾店）", "address": "长宁区新渔路144号" },
          { "value": "三三全全（北新泾店）", "address": "长宁区新渔路144号" },
        ];
      },
      //搜索框的建议列表
      async querySearchAsync(queryString, cb) {
        //内容不等于空字符串
        if (queryString.trim() === '') {
          cb([]);
          return;
        };
        let res= await this.POST_SearchDocHotel({data:{title: queryString,city:''}});//this.searcValue.cityId
        this.timeout = setTimeout(() => {
          cb(res.list);
        }, 2000 * Math.random());
      },
      //点击搜索框的建议项
      handleSelect(item) {
        let changeRoute = this.$router.resolve('/index_hotel/hotel_detail/' + item.id);
        window.open(changeRoute.href, '_blank');
      },

      //打开筛选器
      OpenFilter(index){
        this.defaultIndex!=index?this.defaultIndex=index:this.defaultIndex=0
      },
      //获取热门城市列表
      async getHotCity(){
          let res = await this.POST_GetAllCity({});
          console.log(res);
          this.infoLise = res;
      },
      //获取分类信息
      formData(res){
        this.searcValue={...this.searcValue,...res};
        //关闭
        this.defaultIndex=0;
      },
      //用户点击了输入框
      inputFocus() {
        //关闭所有展开
        this.defaultIndex=0;
      },
      //搜索跳转
      searchJump(item){
        this.$router.push({
          path:'/index_hotel',
          query:{
          ...item,
            star:item.star?item.star.join(','):'',
            brand:item.brand?item.brand.join(','):'',
          }
        });
      },
      //
    },
    destroyed() {
      clearTimeout(this._timer);
      window.onresize = null;
    },
  }
</script>

<style lang="scss" scoped>
  .divimg{
    height: 680px;
    width: 100%;
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    background-attachment: scroll;
    overflow: hidden;
  }
  .index-scroll {
    cursor: pointer;
    position: relative;
    .brandHeight{
      overflow-y: hidden;
      img{
        // width: 100%;
        height: 100%
      }
      ::v-deep.el-carousel__indicators--horizontal{
        bottom: -2px
      }
    }
    .el-carousel__arrow {
      width: 50px;
      height: 50px;
      border: 1px solid #fff;
      background: rgba(255, 255, 255, .4);
      color: #000;
      display: flex;
      justify-content: center;
      align-items: center;
      .el-icon-arrow-left, .el-icon-arrow-right {
        font-size: 30px;
        font-weight: bolder;
      }
      &:hover {
        background: rgba(255, 255, 255, .8);
      }
    }
    ::v-deep.el-carousel__button {
      width: 40px;
      height: 4px;
      border-radius: 10px;
    }
  }
  ::v-deep .el-carousel__indicator{
    padding: 20px 2px;
  }
  .banner{
    position: relative;
  }
    //遮罩层
  .mask{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 6;
  }
  .quickSearch{
    position: absolute;
    top: 50%;
    left: 50%;
    width: 1200px;
    margin: 0 auto;
    height: 560px;
    margin-top: 80px;
    z-index: 2;
    transform: translate(-50%, -50%);
    z-index: 10;
  }
  .quickSearch-wrap{
    width: 100%;
    border: 1px var(--smtc-color-primary) solid;
    background-color: var(--smtc-color-primary);
    color: #fff;
    border-radius: 50px;
    width: 180px;
    padding: 4px 0;
    margin: 0 auto;
    box-shadow: 0px 0px 7px #666;
    /* #12b2cb 半透明，数值可调 */
  }
  .quickSearch-content{
    color: #fff;
  }
  .quickSearch-content h1{
    font-size: 52px;
    margin-top: 18px;
  }
  .quickSearch-content span{
    font-size: 16px;
    margin-top: 12px;
    color: color-mix(in oklab, #fff 70%, transparent);
    display: block;
  }
  .quickSearch-search{
    width: 80%;
    background-color: #fff;
    height: 160px;
    --tw-backdrop-blur: blur(12px);
    border-radius: 16px;
    margin: 0 auto;
    margin-top: 40px;
    --tw-shadow: 0 25px 50px -12px var(--tw-shadow-color, rgb(0 0 0 / 0.25));
    box-shadow:  var(--tw-shadow);
  }
  .inline-input{
    width: 86%;
  }
  .search-wrap{
    width: 94%;
    margin: 20px auto;
    display: flex;
    justify-content: space-between;
  }
  .quickSearch-category{
    display: flex;
    position: relative;
    width: 94%;
    margin: 0 auto;
    color: #Fff;
  }
  .quickSearch-category li{
    position: relative;
  }
  .quickSearch-category li i{
    transition: transform 0.3s ease; /* 平滑旋转 */
  }
  /* 旋转90度（向右） */
  .quickSearch-category li .active {
    transform: rotate(180deg);
  }
  .quickSearch-category .category-wrap{
    margin-top: 12px;
    --tw-backdrop-blur: blur(8px);
    backdrop-filter: var(--tw-backdrop-blur);
    // background-color: #666;
    border: 1px solid #eee;
    color: #333;
    width: 120px;
    height: 60px;
    padding: 0 10px;
    display: flex;
    border-radius: 15px;
    margin-right: 14px;
    position: relative;
    cursor: pointer;
    .category-city{
      width: 60%;
      margin-left: 8%;
      text-align: left;
      display: flex;
      justify-content: center;
      flex-direction: column;
      span{
        font-size: 10px;
        font-weight: normal;
        color: #333;
        margin-top: -4px;
      }
    }
  }
  .quickSearch-category li i{
    line-height: 60px;
    width: 20%; 
    color: var(--smtc-color-primary) !important;
  }
</style>
<style >
.inline-input .el-input__inner{
  border: 1px var(--smtc-color-primary) solid !important;
}
</style>
